
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/zero-manual-reports",
      function () {
        return require("private-next-pages/resources/zero-manual-reports.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/zero-manual-reports"])
      });
    }
  